import type { DescService } from "@bufbuild/protobuf";
import { createClient, type Client, type Transport } from "@connectrpc/connect";

/**
 * Backend (Connect RPC) のベース URL。
 * - ローカル開発: 未設定 (空文字) で同一オリジンに投げ、各アプリの dev サーバー (`src/index.ts`) の
 *   proxyRPC が backend へ中継する (CORS 回避)。
 * - 本番ビルド: `BUN_PUBLIC_BACKEND_URL` を `infrastructure/deploy/<app>/*.jsonc` で注入し、
 *   ブラウザから backend を直接叩く (S3 静的配信のため proxy サーバーが存在しない)。
 */
// `process.env.BUN_PUBLIC_BACKEND_URL` へのリテラルアクセスのみが Bun のフロントエンドバンドラで
// ビルド時に値置換される。`typeof process` などでガードすると その式はブラウザで実行時評価され、
// `process` が存在しないため常に空文字へ倒れてしまう。変数は全アプリの .env.example / 全 deploy jsonc に
// 必ず存在する (ローカルは空文字) 前提で、未設定なら空文字フォールバックする。
export const BACKEND_BASE_URL = process.env.BUN_PUBLIC_BACKEND_URL ?? "";

/**
 * transport を束縛した getServiceClient を返す。interceptor 構成はアプリごとに異なるため、
 * transport は各アプリの `src/lib/client.ts` が組み立てて渡す。
 *
 * 返り値の getServiceClient は任意の Connect-ES サービスに対する型付きクライアントを生成する。
 * BC ごとにファクトリ関数を増やさず、サービスの種類だけで識別する。
 *
 * 使い方:
 *   const client = getServiceClient(AdministratorService);
 *   await client.listUsers({ limit, pageToken });
 */
export function createServiceClientFactory(transport: Transport) {
  return function getServiceClient<S extends DescService>(service: S): Client<S> {
    return createClient(service, transport);
  };
}
